import { forwardRef } from 'react';

import { cn } from '../../utils/cn';

export const Card = forwardRef(function Card({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      data-ds-id="ds/card/base"
      className={cn(
        'rounded-ds-lg border border-border bg-card p-space-5 shadow-md',
        className,
      )}
      {...props}
    />
  );
});

export const CardHeader = forwardRef(function CardHeader(
  { className, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn('mb-space-3 flex flex-col gap-space-1', className)} {...props} />
  );
});

export const CardTitle = forwardRef(function CardTitle(
  { className, children, ...props },
  ref,
) {
  return (
    <h3
      ref={ref}
      className={cn('font-display text-lg font-semibold text-foreground', className)}
      {...props}
    >
      {children}
    </h3>
  );
});

export const CardDescription = forwardRef(function CardDescription(
  { className, ...props },
  ref,
) {
  return (
    <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
  );
});

export const CardContent = forwardRef(function CardContent(
  { className, ...props },
  ref,
) {
  return <div ref={ref} className={cn('text-muted-foreground', className)} {...props} />;
});

export const CardFooter = forwardRef(function CardFooter(
  { className, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('mt-space-4 flex items-center justify-between gap-space-2', className)}
      {...props}
    />
  );
});
